import { motion } from "framer-motion";
import { Lightbulb, Hammer, Rocket, Network } from "lucide-react";
import { INDUSTRY_EXPOSURE } from "@/lib/content";

const ICONS = [Lightbulb, Hammer, Rocket, Network];

export default function IndustryExposure() {
  return (
    <section
      data-testid="industry-exposure"
      className="border-t border-[var(--ri-ink)] bg-[var(--ri-surface-alt)]"
    >
      <div className="ri-container py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">
              <span className="dot mr-2" /> 07 — Innovation Ecosystem
            </div>
            <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95]">
              Beyond the classroom —<br />
              into the{" "}
              <span className="italic font-display-soft">industry</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[var(--ri-muted)] leading-relaxed">
              RoboInsci students don't just learn — they build, pitch and ship. Through hackathons, incubation pipelines and IIC partnerships, we connect institutional learning to real-world impact.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--ri-ink)] border border-[var(--ri-ink)]">
          {INDUSTRY_EXPOSURE.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="bg-white p-7 md:p-8"
                data-testid={`industry-card-${i}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <Icon size={28} strokeWidth={1.4} className="text-[var(--ri-orange)]" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--ri-muted)]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-2xl tracking-tight leading-tight">
                  {item.title}
                </h3>
                <p className="mt-3 text-[var(--ri-muted)] text-sm leading-relaxed">
                  {item.body}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-10 grid md:grid-cols-3 gap-px bg-[var(--ri-ink)] border border-[var(--ri-ink)]" data-testid="ecosystem-rails">
          {[
            "Incubation Centers",
            "Institution Innovation Council (IIC)",
            "Industry & Startup Partners",
          ].map((tag, i) => (
            <div
              key={tag}
              className="bg-[var(--ri-ink)] text-white p-6 flex items-center justify-between"
            >
              <span className="font-display-soft text-lg">{tag}</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-white/50">
                Rail · 0{i + 1}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
